import React from 'react';
import {CheckCircle, TrendingUp} from "lucide-react";
import {formatDate} from "@/lib/helper/date";
import {Divider} from "antd";

function StudentMyLessonPaymentHistorySection({data}) {

    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('fa-IR').format(amount);
    };

    const getTransactionTypeLabel = (paytype, subtype) => {
        if (paytype === 'takelesson') return 'ثبت‌نام دوره';
        if (paytype === 'installment') return 'پرداخت قسط';
        if (paytype === 'refund') return 'بازگشت وجه';
        return 'تراکنش';
    };

    return (
        <>
            {/* Transaction History */}
            <div className=" rounded-2xl shadow-lg p-6 border border-gray-100 dark:border-gray-600 dark:border-gray-600">
                <div className="flex items-center gap-3 mb-6">
                    <div className="p-2 bg-purple-100 rounded-lg">
                        <TrendingUp className="w-6 h-6 text-purple-600"/>
                    </div>
                    <h2 className="text-2xl font-bold">تاریخچه تراکنش‌ها</h2>
                </div>

                <div className="space-y-4">
                    {data?.data?.data?.academytransactions.map((transaction) => (
                        <div key={transaction.id}
                             className="border dark:border-gray-600 rounded-xl p-5 hover:shadow-md transition-all duration-200">
                            <div className="flex items-start justify-between mb-3">
                                <div className="flex-1">
                                    <div className="flex items-center gap-2 mb-2">
                                        <h3 className="font-semibold">{transaction.title}</h3>
                                        {transaction.verify && (
                                            <CheckCircle className="w-4 h-4 text-green-600"/>
                                        )}
                                    </div>
                                    <p className="text-sm  mb-1">
                                        نوع: {getTransactionTypeLabel(transaction.paytype, transaction.subtype)}
                                    </p>
                                    <p className="text-sm ">
                                        تاریخ: {formatDate(transaction.date)}
                                    </p>
                                </div>
                                <div className="text-left">
                                    {transaction.plus > 0 ? (
                                        <div className="text-green-600">
                                            <span
                                                className="text-lg font-bold">+{formatCurrency(transaction.plus)} {' '}
                                                <span className={'text-xs'}>تومان</span></span>
                                            <p className="text-xs">واریز</p>
                                        </div>
                                    ) : (
                                        <div className="text-red-600">
                                            <span
                                                className="text-lg font-bold">-{formatCurrency(transaction.minus)} {' '}
                                                <span className={'text-xs'}>تومان</span></span>
                                            <p className="text-xs">برداشت</p>
                                        </div>
                                    )}
                                </div>
                            </div>

                            <Divider size={'small'} />
                            <div className="flex items-center justify-between pt-3">
                                <div className="flex items-center gap-2">
                                    <span className="text-xs ">شناسه تراکنش:</span>
                                    <span className="text-xs font-mono ">{transaction.id}</span>
                                </div>
                                <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                                    transaction.status === 'enable' && transaction.verify
                                        ? 'bg-green-100 text-green-800 border border-green-200'
                                        : 'bg-red-100 text-red-800 border border-red-200'
                                }`}>
                        {transaction.status === 'enable' && transaction.verify ? 'تأیید شده' : 'در انتظار تأیید'}
                      </span>
                            </div>
                        </div>
                    ))}
                </div>


            </div>
        </>

    );
}

export default StudentMyLessonPaymentHistorySection;